import { StepType, useTour } from '@reactour/tour';
import Content from 'ui/components/common/Tour/Content';
import { TOUR_SELECTOR } from 'ui/partials/Tour';

const useGetHowToQuickCreateCompanySteps = () => {
  const { setIsOpen, setSteps, setCurrentStep } = useTour();

  const quickCreateCompanySteps: StepType[] = [
    {
      content:
        'Click on the + Create button at the upper left corner of your screen.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.GENERAL_CREATE.CREATE}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(1), 200);
          },
          false,
        );
      },
    },
    {
      content: 'Click on the Create Company option.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.GENERAL_CREATE.COMPANY}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(2), 200);
          },
          false,
        );
      },
    },
    {
      content: (props) => (
        <Content
          {...props}
          content={
            // eslint-disable-next-line max-len
            'Fill out the form with the company’s information, such as company name, industry, and type.'
          }
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CONTACT.COMPANY.FORM.GENERAL.FORM}"]`,
      highlightedSelectors: [
        '[data-tut="global_create_panel_header"]',
        `[data-tut="${TOUR_SELECTOR.TOUR.CONTACT.COMPANY.FORM.GENERAL.FORM}"]`,
      ],
      position: 'left',
      padding: 22,
    },
    {
      content: 'Click Save and you are done.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CONTACT.COMPANY.FORM.GENERAL.SAVE_BUTTON}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setCurrentStep(0);
            setSteps?.([]);
          },
          false,
        );
      },
      position: 'top',
    },
  ];

  const showQuickCreateCompanySteps = () => {
    setTimeout(() => {
      setSteps?.(quickCreateCompanySteps);
      setIsOpen(true);
    }, 300);
  };

  return showQuickCreateCompanySteps;
};

export default useGetHowToQuickCreateCompanySteps;
